import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BirthdateReportComponent } from './birthdate-report/birthdate-report.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { DirectivesModule } from '@directives/directives.module';
import { CustomInputsModule } from '@forms/custom-inputs/custom-inputs.module';
import { MatTableModule } from '@angular/material/table';
import { BirthdateDetailsModalComponent } from './birthdate-report/modals/birthdate-details-modal/birthdate-details-modal.component';
import { PortfolioManagementReportComponent } from './portfolio-management-report/portfolio-management-report.component';
import { PortfolioManagementDetailsReportModalComponent } from './portfolio-management-report/modals/portfolio-management-details-report-modal/portfolio-management-details-report-modal.component';
import { SalesReportComponent } from './sales-report/sales-report.component';
import { UsageGraphComponent } from './sales-report/components/usage-graph/usage-graph.component';
import { NgChartsModule } from 'ng2-charts';
import { SalesDetailsModalComponent } from './sales-report/modals/sales-details-modal/sales-details-modal.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ContemplationPaymentComponent } from './contemplation-payment/contemplation-payment.component';
import { CommissionsReportComponent } from './commissions-report/commissions-report.component';
import { CommissionsReportFilterComponent } from './commissions-report/commissions-report-filter/commissions-report-filter.component';
import { DetailViewerModalComponent } from './commissions-report/detail-viewer-modal/detail-viewer-modal.component';
import { ProfileDataModalComponent } from './commissions-report/profile-data-modal/profile-data-modal.component';

// Imports the Shared module to acess the reports
@NgModule({
  declarations: [
    BirthdateReportComponent,
    BirthdateDetailsModalComponent,
    PortfolioManagementReportComponent,
    PortfolioManagementDetailsReportModalComponent,
    SalesReportComponent,
    SalesDetailsModalComponent,
    UsageGraphComponent,
    ContemplationPaymentComponent,
    CommissionsReportComponent,
    CommissionsReportFilterComponent,
    DetailViewerModalComponent,
    ProfileDataModalComponent,
  ],
  imports: [
    CommonModule,
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatButtonModule,
    DirectivesModule,
    CustomInputsModule,
    MatTableModule,
    FormsModule,
    NgChartsModule,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    UsageGraphComponent
  ]
})
export class ReportsModule { }
